import { external, globe } from '@wordpress/icons';
import { FlexBlock } from '@wordpress/components';
import { useTranslate } from 'i18n-calypso';

import useHostPartnerQuery from 'data/signup/use-host-partner-query';
import Spinner from 'components/spinner';
import Sidebar from 'components/sidebar';

export default function OverviewSidebar() {
	const translate = useTranslate();
	const { data, isSuccess } = useHostPartnerQuery();

	if ( ! isSuccess ) {
		return (
			<Sidebar>
				<div className="h-full flex justify-center items-center">
					<Spinner big />
				</div>
			</Sidebar>
		);
	}

	if ( ! data ) {
		return null;
	}

	const hasJetpackPartnership = !! data?.host_partner?.partnerships?.jetpack;
	const hasA4A = !! data?.host_partner?.partnerships?.a4a;

	return (
		<Sidebar>
			<Sidebar.Navigator initialPath={ '/' }>
				<Sidebar.NavigatorMenu
					path={ '/' }
					title={ translate( 'Overview' ) }
					description={ translate( 'Manage all of your Automattic partner accounts in one place.' ) }
				>

					<Sidebar.Button path="/wpcloud">
						<Sidebar.ButtonIcon icon={ globe } />
						<FlexBlock>{ translate( 'WP Cloud' ) }</FlexBlock>
						<Sidebar.ButtonChevron />
					</Sidebar.Button>

					<Sidebar.Button
						path={ hasJetpackPartnership ? '/jetpack' : 'https://jetpack.com/jetpack-partners/' }
						target={ hasJetpackPartnership ? '_self' : '_blank' }
					>
						<Sidebar.ButtonIcon icon={ globe } />
						<FlexBlock>{ translate( 'Jetpack' ) }</FlexBlock>
						{
							hasJetpackPartnership ? <Sidebar.ButtonChevron /> : <Sidebar.ButtonIcon icon={ external } />
						}
					</Sidebar.Button>

					<Sidebar.Button
						path={ hasA4A ? 'https://agencies.automattic.com' : 'https://automattic.com/for-agencies/' }
						target={ hasA4A ? '_self' : '_blank' }
					>
						<Sidebar.ButtonIcon icon={ globe } />
						<FlexBlock>{ translate( 'Agencies' ) }</FlexBlock>
						{
							hasA4A ? <Sidebar.ButtonChevron /> : <Sidebar.ButtonIcon icon={ external } />
						}
					</Sidebar.Button>

				</Sidebar.NavigatorMenu>
			</Sidebar.Navigator>
		</Sidebar>
	);
}
